import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import { useState } from "react";
import Axios from "axios";

const TermNote = props => {
    const [show, hide, renderModal] = useModal();
    const [note, setNote] = useState();
    const [error, setError] = useState();

    return (
        <React.Fragment>
            <button className={"button icon-button " + props.className} onClick={() => {
                show();
                //load data
                Axios.get(`${window.API_URL}/glossary/getTermNote.php?termID=${props.termID}`).then(response => {
                    setNote(response.data.data.note);
                }).catch(error => {
                    setError(error.message);
                });
            }}><i className="fas fa-sticky-note"></i></button>
            {renderModal(
                <div>
                    <div className="group">
                        <div className="label">Note</div>
                        <textarea className="input" onInput={e => setNote(e.target.value)} value={note}></textarea>
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    {<LoadingButton onClick={e => {}} className="">Update</LoadingButton>}
                </div>
            )}
        </React.Fragment>
    )
}

export default TermNote;